import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Container } from 'react-bootstrap';
import ContactBanner from '../../components/contactBanner/ContactBanner';
import FaqWidget from '../../components/faqWidget';
import TopBanner from '../../components/topBanner';
import AffiliateProgramWidget from '../../components/affiliateProgramWidget';
import AffiliateFiguresWidget from '../../components/affiliateFiguresWidget';
import affiliateBanner from '../../assets/img/affiliate-banner.svg';
import releaseIcon from '../../assets/img/release-icon.svg';
import './affiliateProgram.scss';

function AffiliateProgramPage() {
    const { t } = useTranslation();
    return (
        <>
            <Helmet>
                <title>{t('titles.affiliate-program')}</title>
            </Helmet>
            <div className="affiliate-program-wrapper">
                <TopBanner
                    bannerImage={<img src={affiliateBanner} alt="Affiliate banner" />}
                    className="web-top-banner"
                >
                    <>
                        <h1 className="banner-header">{t('affiliate-page.top-banner-title')}</h1>
                        <h2 className="banner-sub-header">
                            {t('affiliate-page.top-banner-subtitle')}
                        </h2>
                        <p className="banner-sub-text">{t('affiliate-page.top-banner-text')}</p>
                        <ul className="banner-list">
                            <li className="banner-item">
                                <img src={releaseIcon} alt="List item" />
                                <p
                                    className="banner-text"
                                    dangerouslySetInnerHTML={{
                                        __html: t('affiliate-page.top-banner-text-1')
                                    }}
                                />
                            </li>
                            <li className="banner-item">
                                <img src={releaseIcon} alt="List item" />
                                <p
                                    className="banner-text"
                                    dangerouslySetInnerHTML={{
                                        __html: t('affiliate-page.top-banner-text-2')
                                    }}
                                />
                            </li>
                            <li className="banner-item">
                                <img src={releaseIcon} alt="List item" />
                                <p className="banner-text">
                                    {t('affiliate-page.top-banner-text-3')}
                                </p>
                            </li>
                            <li className="banner-item">
                                <img src={releaseIcon} alt="List item" />
                                <p className="banner-text">
                                    {t('affiliate-page.top-banner-text-4')}
                                </p>
                            </li>
                        </ul>
                    </>
                </TopBanner>
                <section className="section-wrapper program-section">
                    <Container>
                        <div className="section-top">
                            <h2
                                className="section-title"
                                dangerouslySetInnerHTML={{
                                    __html: t('affiliate-page.program-title')
                                }}
                            />
                            <p className="section-text">{t('affiliate-page.program-text')}</p>
                        </div>
                        <AffiliateProgramWidget />
                    </Container>
                </section>
                <section className="section-wrapper figures-section">
                    <Container>
                        <div className="section-top">
                            <h2
                                className="section-title"
                                dangerouslySetInnerHTML={{
                                    __html: t('affiliate-page.figures-title')
                                }}
                            />
                            <p className="section-text">{t('affiliate-page.figures-text')}</p>
                        </div>
                        <AffiliateFiguresWidget />
                    </Container>
                </section>
                <section className="regular-banner p-5">
                    <h3 className="banner-title">{t('banners.regular-banner-affiliate-text')}</h3>
                </section>
                <section className="section-wrapper faq-section">
                    <Container>
                        <div className="section-top">
                            <h2
                                className="section-title"
                                dangerouslySetInnerHTML={{
                                    __html: t('affiliate-page.faq-title')
                                }}
                            />
                            <p className="section-text">{t('affiliate-page.faq-text')}</p>
                        </div>
                        <FaqWidget dataType="affiliate" />
                    </Container>
                </section>
                <ContactBanner />
            </div>
        </>
    );
}

export default AffiliateProgramPage;
